import { get, writable } from 'svelte/store';
import { storeResults } from '../services/storage.service.js';
import { errorCodes } from '../helpers/errorHelper.js';
import { omitEmpty } from '../pages/diagnostic/results.utils.js';

function createResultsStore () {
    const INITIAL_VALUE = {
        endpointsReachability: null,
        browserCompatibility: null,
        connectionCompatibility: null,
        audioCompatibility: null,
        audio: null,
        webSocketCompatibility: null,
    };
    const resultsStore = writable({ ...INITIAL_VALUE });
    const { update, set, subscribe } = resultsStore;

    return {
        subscribe,
        updateLocalResults(newResults) {
            update(oldResults => ({
                ...oldResults,
                ...newResults,
            }));
        },
        resetLocalResults() {
            set({
                ...INITIAL_VALUE
            });
        },
        async uploadResultsAndMeta(results, meta) {
            this.updateLocalResults(results);

            return storeResults(
                omitEmpty({
                    ...get(resultsStore),
                    ...meta,
                })
            ).catch(() => Promise.reject({ code: errorCodes.savingFailure }));
        }
    }
}

export default createResultsStore();

